import React, { useEffect, useState } from "react";
import axios from "axios";

const AdminPendingComments = ({ user, isLoggedIn, login }) => {
  const [pendingComments, setPendingComments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const fetchPendingComments = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/comments/admin/pending`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      setPendingComments(res.data);
    } catch (err) {
      setError(
        err.response?.data?.message || "Failed to load pending comments"
      );
    }
    setLoading(false);
  };

  const approveComment = async (commentId) => {
    setError(null);
    setSuccess(null);
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/comments/admin/approve/${commentId}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      setSuccess(res.data.message);
      setPendingComments((prev) => prev.filter((c) => c._id !== commentId));
    } catch (err) {
      setError(err.response?.data?.message || "Failed to approve comment");
    }
  };

  const rejectComment = async (commentId) => {
    setError(null);
    setSuccess(null);
    try {
      const res = await axios.delete(
        `${process.env.REACT_APP_BACKEND_URL}/api/comments/admin/reject/${commentId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      setSuccess(res.data.message);
      setPendingComments((prev) => prev.filter((c) => c._id !== commentId));
    } catch (err) {
      setError(err.response?.data?.message || "Failed to reject comment");
    }
  };

  useEffect(() => {
    fetchPendingComments();
  }, []);

  return (
    <div style={{ padding: "20px", maxWidth: 900, margin: "0 auto" }}>
      <h2>Pending Comments</h2>

      {loading && (
        <div style={{ width: "100%", marginBottom: 10 }}>
          <div
            style={{
              height: 4,
              backgroundColor: "#1976d2",
              animation: "loading 2s linear infinite",
            }}
          />
          <style>{`
            @keyframes loading {
              0% { width: 0%; }
              50% { width: 50%; }
              100% { width: 100%; }
            }
          `}</style>
        </div>
      )}

      {error && <p style={{ color: "red" }}>{error}</p>}
      {success && <p style={{ color: "green" }}>{success}</p>}

      {!loading && pendingComments.length === 0 && <p>No pending comments.</p>}

      {pendingComments.length > 0 && (
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            marginTop: 10,
          }}
        >
          <thead>
            <tr style={{ borderBottom: "2px solid #ddd" }}>
              <th style={{ padding: "8px", textAlign: "left" }}>User</th>
              <th style={{ padding: "8px", textAlign: "left" }}>Tool ID</th>
              <th style={{ padding: "8px", textAlign: "left" }}>Comment</th>
              <th style={{ padding: "8px", textAlign: "center" }}>Approve</th>
              <th style={{ padding: "8px", textAlign: "center" }}>Reject</th>
            </tr>
          </thead>
          <tbody>
            {pendingComments.map((comment) => (
              <tr
                key={comment._id}
                style={{
                  borderBottom: "1px solid #eee",
                }}
              >
                <td style={{ padding: "8px" }}>{comment.username}</td>
                <td style={{ padding: "8px" }}>{comment.toolId}</td>
                <td style={{ padding: "8px" }}>{comment.content}</td>
                <td style={{ padding: "8px", textAlign: "center" }}>
                  <button onClick={() => approveComment(comment._id)}>Approve</button>
                </td>
                <td style={{ padding: "8px", textAlign: "center" }}>
                  <button
                    style={{ backgroundColor: "#f44336", color: "white", border: "none", padding: "6px 12px", cursor: "pointer" }}
                    onClick={() => rejectComment(comment._id)}
                  >
                    Reject
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default AdminPendingComments;
